import http from '../common/http'


export const login = (param) =>{
  return http.requestPost('/login/login',param);
}
export const logout = (param) =>{
  return http.requestPost('/login/logout',param);
}
export const getCodeImg =(randomStr) =>{
  //获取拼图验证
  return http.requestPost(`/login/getCodeImg?randomStr=${randomStr}`);  
}
export const checkVerify = (x,randomStr)=>{
  //检查拼图验证
  return http.requestPost(`/login/checkVerify?x=${x}&randomStr=${randomStr}`);  
}
